import React from "react";
import { nanoid } from "nanoid";

const ExitIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    className="tw-w-5 tw-ml-2"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const unCamelCase = (str) =>
  (str[0].toUpperCase() + str.slice(1))
    .split(/(?=[A-Z])/)
    .map((word) => (word.length > 2 ? word : word[0].toLowerCase() + word[1]))
    .join(" ")
    .replace("Desc", "Type");

const CurrentFilterToolbar = (props) => {
  const { currentFilters } = props;
  const displayedFilters = Object.keys(currentFilters).map(
    (key) =>
      currentFilters[key].length !== 0 && (
        <div key={key}>
          <div className="tw-gap-2 tw-flex sm:tw-flex-row tw-flex-col tw-ml-8 sm:tw-ml-0 tw-flex-wrap tw-items-start sm:tw-justify-start sm:tw-items-stretch">
            <h3 className="tw-my-auto tw-py-0 tw-w-40">{unCamelCase(key)}:</h3>
            {props.currentFilters[key].map((item) => (
              <button
                onClick={(e) => {
                  props.onClick(e, key);
                }}
                key={nanoid()}
                value={item}
                className="js-filter-btn tw-px-4 tw-items-center tw-bg-gray-400 tw-flex tw-space-x-4 tw-py-1 tw-border-0 bg-white tw-px-1"
              >
                {item}
                <ExitIcon />
              </button>
            ))}
          </div>
        </div>
      )
  );
  return (
    <div className="filters">
      <h2 className="tw-text-left tw-mb-4">Filters</h2>
      <div className="tw-mb-12 tw-flex-col tw-space-y-4 tw-flex tw-items-start sm:tw-items-start">
        {displayedFilters}
      </div>
    </div>
  );
};

export default CurrentFilterToolbar;
